"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var joi_1 = __importDefault(require("@hapi/joi"));

var use_modal_toggle_state_hook_1 = __importDefault(require("../../hooks/use-modal-toggle-state.hook"));

var editable_image_option_view_styles_1 = require("./editable-image-option-view.styles");

var editable_parsed_variable_text_component_1 = __importDefault(require("../editable-parsed-variable-text/editable-parsed-variable-text.component"));

var select_image_modal_component_1 = __importDefault(require("../select-image-modal/select-image-modal.component"));
/* validation
----------------------------------*/


var IMAGE_NAME_MAX_LENGTH = 12;
var ERROR_MESSAGE = "1\u6587\u5B57\u4EE5\u4E0A".concat(IMAGE_NAME_MAX_LENGTH, "\u6587\u5B57\u4EE5\u4E0B\u306E\u5024\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");

var isValidImageName = function isValidImageName(parsedText) {
  var schema = joi_1.default.string().max(IMAGE_NAME_MAX_LENGTH).required();

  var _schema$validate = schema.validate(parsedText),
      error = _schema$validate.error;

  return {
    error: error ? ERROR_MESSAGE : null
  };
};

var EditableImageOptionView = function EditableImageOptionView(_ref) {
  var imageUrl = _ref.imageUrl,
      imageName = _ref.imageName,
      updateImageUrl = _ref.updateImageUrl,
      updateImageName = _ref.updateImageName;

  var _use_modal_toggle_sta = use_modal_toggle_state_hook_1.default(),
      modalProps = _use_modal_toggle_sta.modalProps,
      handleOpen = _use_modal_toggle_sta.handleOpen;

  return react_1.default.createElement(editable_image_option_view_styles_1.StyledEditableImageOptionDiv, {
    imageUrl: imageUrl,
    "data-meta": "image-option"
  }, react_1.default.createElement(editable_image_option_view_styles_1.StyledEditableImageNameDiv, null, react_1.default.createElement(editable_parsed_variable_text_component_1.default, {
    rawText: imageName,
    handleSavedRawText: function handleSavedRawText(iamgeName) {
      return updateImageName(iamgeName);
    },
    validate: isValidImageName
  })), react_1.default.createElement(editable_image_option_view_styles_1.StyleOverlayDiv, {
    onClick: handleOpen
  }), react_1.default.createElement(select_image_modal_component_1.default, Object.assign({}, modalProps, {
    onImageSelected: function onImageSelected(image) {
      return updateImageUrl(image.url);
    }
  })));
};

exports.default = EditableImageOptionView;